import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AgendaSection = "overdue" | "dueToday" | "scheduledVisits" | "snoozed";

interface AgendaState {
    sectionVisibility: Record<AgendaSection, boolean>;
}

export const initialState: AgendaState = {
    sectionVisibility: {
        overdue: true,
        dueToday: true,
        scheduledVisits: true,
        snoozed: false,
    },
};

export const agendaSlice = createSlice({
    name: "agenda",
    initialState,
    reducers: {
        toggleAgendaSection: (state, action: PayloadAction<AgendaSection>) => {
            state.sectionVisibility[action.payload] =
                !state.sectionVisibility[action.payload];
        },
    },
});
